import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionSafety, logisticsAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import video from '@src/assets/images/solution/medicalPatient/video/rtlsVideo.mp4';

export default {
  desc: 'UWB (Ultra-wideband) là một giao thức truyền thông không dây hoạt động ở tần số rất cao với mức tiêu thụ điện năng thấp. Không giống như các giao thức truyền thông không dây khác như Bluetooth hoặc Wi-Fi, UWB sử dụng các xung năng lượng điện từ ngắn để truyền dữ liệu. Các xung này thường chỉ kéo dài vài nanosecond, nhưng lại có băng thông cực kỳ rộng, từ hàng trăm megahertz đến vài gigahertz.',
  keywords:
    'UWB, Tự động hoá công nghiệp, Tu dong hoa cong nghiep, Quản lý tài sản, Quan ly tai san, Định vị trong nhà, Dinh vi trong nha, Xác định vị trí trong nhà, Xac dinh vi tri trong nha',
  ogSite: 'UWB là gì? Những lợi ích cho doanh nghiệp?',
  title: 'UWB là gì? Những lợi ích cho doanh nghiệp?',
  ogUrl: 'https://orbro.io/vi/blog/uwb',
  ogImg:
    'https://lh3.googleusercontent.com/fife/APg5EObeDoLPWDY0m4J6RG5ivUvly0sFp1k2N8pJ6vwHvfEotnTR-c97QjquFgftQfhSf8tMXrczrcxhZelBBXIc0FoSa6ZZgE8na0u8s66yPDrdq0UrGeG-BtDEHMU8P-DPTgUQcwgdX_770Njyx6SNDF4Bchooan8k2Ghgf5DDf0A-rOW2q8-J9DNpNr9pjZRVCg6601CXYmQ-4C_DWZQrQPOpbyvi0Utlc-Az8WhS41m0SPy_AVoqe-fxEuq53t-bNal_-D9ko7jhgr3HHIaTqLbFKWfu5W_yVuf3-clrf0CtlwYyWeQTD4-blr1Vt6UMEpe6g0xh8vMdEG9KwIOY0We-an0hHPhqHco-cxMhZqnXuKuhdRngKsVJnmNzhoAGDcEovW0xEdbwNGGnaXf9HgDuwEyz0O0hBJ1VdMLVrZeF3yG2w0uOYvT1w1CGsNnOvF1HQ2O1tBB0OUXGi7kOuhASd34xinm8ZUoaopcdehwOHmFkiWhblS3O86GDhcSHi64o5o9yPXeKJKcg3aX4M1WKjSD4u-v_h7Cz7j2Ew_QRGSJUkV0ZqKIYM-LnidAHxkTwv5b0vujpTQTybOQctctEpk07QqA7jx3zz1AbtSgtB4SMS3BVYQ-LDQPwmRnkVEi15VK5I33OFLSw8UAoibRcC2y68nu5w0ZmwZ3yZPgRbGUhwVnNrbzmmWjnhyW6agO6gnb3iAAYmxGgUZ0Bxe6sU3F_hRAOk3K5adG-GTihhhRZ6Ny-1YfLjwBN2XWS9CQmHOiNL2XKyUmDIRFnYf6My62MYUpTGkqD3QGMb5QWsmjsVvMDeYmPK2pRmdXC2VuzOpXv1I32Uij5MECw_kBbt9J59P_jtayKMJb7MPa9mZTsvEtK68fS4kpKPiTqgmY6Fpu81ySeLX6iMqgw2mW8BqPuEyOz5VlDQR8kXkleyutpFfgwMLd0gDe-6V-1w-4lb3u6ccuCTShoIl4rzEil0_RJbe2Oe3td0WW3KYtfT_1Oeihe7jPGmD0JZrOSemw8nMa-oWOjkMSMFpCBJOfSPxpx5I42Jupgd2vOsaIezrcSGCGzHpoXM2-ryc14nPGOUDOc-hA1eFFGqVgCGUQN2dUMHISspskEVJBPI7647sxsyCnd0IUJLN5NSHR_sHivHXsX3SAq9g2Tk3WwbdpT8PW2l9hw6FfuxvjBv8DfsEILwnTGOQQMQ8iiQIZLz9QyCq1OEEDethUDWNsTZipSUMrcWUwpyNxE5586r4DxKO0R_AIGUIxL7kAAwP5cRdFP7CxE1UBRhidxzIVJeIaoHrk-OtutFpM4iFhXD6VY_zZRNDnT74KvBOONaMhB3Lhc801EddUkWf0-35rZksJbpbnWR-H_yNKiCBv8UP9iHJoUWB84wFs2dUNq8sK7fy316q-Coz-Yc58zY_S07R8mK_SjMcdJPDpUc-XzfMyXvXGhYWScpZjP766CDtHOd_ArlWxMsLBupquNSUuHJJ6FWmIoUzq31LSeNqPvc7MH_ywbqQd_efx2p8c73E_NvkVCJP8OYYT8IP8iUh9v7tRMD0-JBjW6yzXknRIpicPYTQ=w2059-h1216',

  ogType: 'website',
  date: '2023-04-25',
  tag1: '#UWB',
  tag2: '#Tudonghoacongnghiep',
  tag3: '#Quanlytaisan',
  tag4: '#Dinhvitrongnha #Xacdinhvitritrongnha',
  text: [
    {
      head: 'UWB là gì?',
      subHead: '',
      desc: 'UWB (Ultra-wideband) là một giao thức truyền thông không dây hoạt động ở tần số rất cao với mức tiêu thụ điện năng thấp. Không giống như các giao thức truyền thông không dây khác như Bluetooth hoặc Wi-Fi, UWB sử dụng các xung năng lượng điện từ ngắn để truyền dữ liệu. Các xung này thường chỉ kéo dài vài nanosecond, nhưng lại có băng thông cực kỳ rộng, từ hàng trăm megahertz đến vài gigahertz.\nBăng thông rộng của UWB rất hữu ích cho các ứng dụng đòi hỏi truyền dữ liệu dung lượng lớn một cách nhanh chóng và chính xác, chẳng hạn như tự động hóa công nghiệp, robot và xe tự lái. Ngoài ra, UWB có thể đo khoảng cách giữa hai vật thể một cách rất chính xác, giúp nó hữu ích trong các ứng dụng dựa trên vị trí.',
      dot: '',
    },
    {
      head: 'UWB có thể giúp ích gì cho doanh nghiệp?',
      subHead: '',
      desc: 'UWB có nhiều ứng dụng tiềm năng khác nhau, do đó nó có thể hỗ trợ doanh nghiệp theo nhiều cách. Dưới đây là một số ứng dụng thực tiễn, hứa hẹn nhất của UWB.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Xác định vị trí trong khu vực và theo dõi tài sản',
      desc: 'Công nghệ UWB có thể được sử dụng để theo dõi chính xác vị trí của tài sản bên trong các tòa nhà hoặc không gian kín khác. Việc này rất hữu ích trong việc quản lý hàng kho, theo dõi công cụ, kiểm soát công cụ, giám sát quy trình, theo dõi phương tiện và các ứng dụng khác đòi hỏi dữ liệu vị trí chính xác. Ví dụ: nếu bạn điều hành một nhà kho, bạn có thể sử dụng UWB để theo dõi vị trí của từng mặt hàng theo thời gian thực, giúp bạn tìm và quản lý kho hàng dễ dàng hơn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hệ thống thanh toán không tiếp xúc',
      desc: 'Công nghệ UWB có thể được sử dụng để triển khai các hệ thống thanh toán không tiếp xúc an toàn và đáng tin cậy hơn so với các giải pháp hiện có. Bằng cách sử dụng UWB để truyền dữ liệu thanh toán giữa thiết bị di động và thiết bị đầu cuối thanh toán, bạn có thể đảm bảo rằng các giao dịch thanh toán được thực hiện an toàn và không có gian lận hoặc truy cập trái phép.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tự động hóa cho nhà thông minh',
      desc: 'Công nghệ UWB có thể được sử dụng để tạo ra các hệ thống tự động hóa nhà thông minh một cách chính xác và đáng tin cậy hơn so với các giải pháp hiện có. Bằng cách sử dụng UWB để xác định vị trí của các thiết bị trong nhà, bạn có thể tạo ra các hệ thống tự động hóa phức tạp hơn, phản ứng với các vị trí hoặc chuyển động cụ thể. Ví dụ: bạn có thể tạo ra một hệ thống đèn tự động bật lên khi ai đó bước vào phòng và tự động tắt khi rời đi.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giám sát chăm sóc sức khỏe',
      desc: 'Công nghệ UWB có thể được sử dụng để theo dõi vị trí và chuyển động của bệnh nhân trong các cơ sở y tế, đảm bảo rằng họ nhận được sự chăm sóc cần thiết. Ví dụ: UWB có thể giúp theo dõi chuyển động của bệnh nhân trong bệnh viện, cho phép nhân viên y tế nhanh chóng xác định vị trí những bệnh nhân có thể cần giúp đỡ.',
      dot: '',
    },
    {
      head: '',
      subHead: 'An toàn ô tô',
      desc: 'Công nghệ UWB có thể được sử dụng trong các hệ thống an toàn ô tô bằng cách cung cấp dữ liệu chính xác hơn về vị trí và chuyển động của xe, rất hữu ích trong các ứng dụng như tránh va chạm. Trong đó UWB có thể được sử dụng để xác định chính xác khoảng cách giữa hai xe và cảnh báo người lái về những nguy hiểm tiềm ẩn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tự động hóa công nghiệp',
      desc: 'Công nghệ UWB có thể cung cấp tín hiệu chính xác và đáng tin cậy hơn giữa các thiết bị có ứng dụng tự động hóa công nghiệp. Ví dụ: UWB có thể được sử dụng để truyền dữ liệu giữa robot và các thiết bị công nghiệp khác, cho phép chúng phối hợp hiệu quả hơn, tăng năng suất lao động.',
      dot: '',
    },
    {
      head: 'Kết luận',
      subHead: '',
      desc: 'Công nghệ UWB là một công cụ mạnh mẽ có thể được sử dụng trong nhiều ứng dụng khác nhau, từ theo dõi vị trí trong khu vực, quản lý tài sản cho đến tự động hóa nhà thông minh và giám sát y tế. Độ chính xác và độ tin cậy cao của công nghệ giúp trở thành một lựa chọn lý tưởng cho các ứng dụng đòi hỏi dữ liệu vị trí chính xác, hoặc truyền dữ liệu tốc độ cao.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
